import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseCustomView, RCustomView} from './customViewModel';
import {parseDelegation, RDelegation} from './delegationModel';
import {parseInbox, RInbox} from './inboxModel';

/*
 * Runtime types.
 */

const RPushDelegationDirty = t.readonly(
  t.type({
    delegation: RDelegation,
    customViews: t.readonlyArray(RCustomView),
    inboxes: t.readonlyArray(RInbox),
  }),
);

/*
 * Type.
 */

export interface PushDelegationModel extends t.TypeOf<typeof RPushDelegationDirty> {}
export const RPushDelegation = t.clean<PushDelegationModel>(RPushDelegationDirty as any);

/*
 * IO methods.
 */

export function parsePushDelegation(src: any): PushDelegationModel {
  return {
    delegation: parseDelegation(src),
    customViews: (src.custom_views && src.custom_views.map((c: any) => parseCustomView(c))) || [],
    inboxes: (src.inboxes || []).map(parseInbox),
  };
}

/*
 * API type.
 */

export const ApiPushDelegation = makeApiType('pushDelegation', RPushDelegationDirty, parsePushDelegation);
